import { PostEtrmConfigAction } from "../../store";
import styled from "styled-components";
import { IEtrmConfig } from "../../services";
import { useAppDispatch } from "../../store";
import { useState } from "react";
import { FormField, Modal, TextInput, Variants } from "@sede-enterprise/shell-ds-react-framework";

const ColumnDiv = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-evenly;
  gap: 10px;
`;

interface IEtrmConfigEntityProps {
  etrmConfig: IEtrmConfig;
  onCancel: () => void;
}

export const EditEtrmConfigEntity = ({
  etrmConfig,
  onCancel,
}: IEtrmConfigEntityProps) => {
  const dispatch = useAppDispatch();
  const open = true;
  const [id] = useState<number>(etrmConfig.id);
  const [code, setCode] = useState<string>(etrmConfig.code.toString());
  const [currency, setCurrency] = useState<string>(
    etrmConfig.currency?.toString()
  );
  const [importType, setImportType] = useState<string>(
    etrmConfig.importType?.toString()
  );
  const [auditType, setAuditType] = useState<string>(
    etrmConfig.auditType?.toString()
  );
  const [tradeType2, setTradeType2] = useState<string>(
    etrmConfig.tradeType2?.toString()
  );
  const [buySell, setBuySell] = useState<string>(
    etrmConfig.buySell?.toString()
  );
  const [optType, setOptType] = useState<string>(
    etrmConfig.optType?.toString()
  );
  const [mkt1, setMkt1] = useState<string>(etrmConfig.mkt1?.toString());
  const [mkt2, setMkt2] = useState<string>(etrmConfig.mkt2?.toString());
  const [comp1, setComp1] = useState<string>(etrmConfig.comp1?.toString());
  const [comp2, setComp2] = useState<string>(etrmConfig.comp2?.toString());
  const [book, setBook] = useState<string>(etrmConfig.book?.toString());
  const [firmType, setFirmType] = useState<string>(
    etrmConfig.firmType?.toString()
  );
  const [schedule, setSchedule] = useState<string>(
    etrmConfig.schedule?.toString()
  );
  const [broker, setBroker] = useState<string>(etrmConfig.broker?.toString());
  const [trader, setTrader] = useState<string>(etrmConfig.trader?.toString());
  const [contract, setContract] = useState<string>(
    etrmConfig.contract?.toString()
  );
  const [unit, setUnit] = useState<string>(etrmConfig.unit?.toString());
  const [period, setPeriod] = useState<string>(etrmConfig.period?.toString());
  const [days, setDays] = useState<string>(etrmConfig.days?.toString());
  const [tGroup1, setTGroup1] = useState<string>(
    etrmConfig.tGroup1?.toString()
  );
  const [tGroup4, setTGroup4] = useState<string>(
    etrmConfig.tGroup4?.toString()
  );
  const [timezone, setTimezone] = useState<string>(
    etrmConfig.timezone?.toString()
  );
  const [inAreaEicCode, setInAreaEicCode] = useState<string>(
    etrmConfig.inAreaEicCode?.toString()
  );
  const [outAreaEicCode, setOutAreaEicCode] = useState<string>(
    etrmConfig.outAreaEicCode?.toString()
  );
  const [corridorCode, setCorridorCode] = useState<string>(
    etrmConfig.corridorCode?.toString()
  );
  const [createdDateTime, setCreatedDateTime] = useState<Date>(
    etrmConfig?.createdDateTime
  );
  const [updatedDateTime, setUpdatedDateTime] = useState<Date>(
    etrmConfig?.updatedDateTime
  );

  const changeCode = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCode(e.target.value);
  };
  const changeCurrency = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCurrency(e.target.value);
  };
  const changeImportType = (e: React.ChangeEvent<HTMLInputElement>) => {
    setImportType(e.target.value);
  };
  const changeAuditType = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAuditType(e.target.value);
  };
  const changeTradeType2 = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTradeType2(e.target.value);
  };
  const changeBuySell = (e: React.ChangeEvent<HTMLInputElement>) => {
    setBuySell(e.target.value);
  };
  const changeOptType = (e: React.ChangeEvent<HTMLInputElement>) => {
    setOptType(e.target.value);
  };
  const changeMkt1 = (e: React.ChangeEvent<HTMLInputElement>) => {
    setMkt1(e.target.value);
  };
  const changeMkt2 = (e: React.ChangeEvent<HTMLInputElement>) => {
    setMkt2(e.target.value);
  };
  const changeComp1 = (e: React.ChangeEvent<HTMLInputElement>) => {
    setComp1(e.target.value);
  };
  const changeComp2 = (e: React.ChangeEvent<HTMLInputElement>) => {
    setComp2(e.target.value);
  };
  const changeBook = (e: React.ChangeEvent<HTMLInputElement>) => {
    setBook(e.target.value);
  };
  const changeFirmType = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFirmType(e.target.value);
  };
  const changeSchedule = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSchedule(e.target.value);
  };
  const changeBroker = (e: React.ChangeEvent<HTMLInputElement>) => {
    setBroker(e.target.value);
  };
  const changeTrader = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTrader(e.target.value);
  };
  const changeContract = (e: React.ChangeEvent<HTMLInputElement>) => {
    setContract(e.target.value);
  };
  const changeUnit = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUnit(e.target.value);
  };

  const changePeriod = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPeriod(e.target.value);
  };
  const changeDays = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDays(e.target.value);
  };
  const changeTGroup1 = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTGroup1(e.target.value);
  };
  const changeTGroup4 = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTGroup4(e.target.value);
  };
  const changeTimezone = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTimezone(e.target.value);
  };
  const changeInAreaEicCode = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInAreaEicCode(e.target.value);
  };
  const changeOutAreaEicCode = (e: React.ChangeEvent<HTMLInputElement>) => {
    setOutAreaEicCode(e.target.value);
  };
  const changeCorridorCode = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCorridorCode(e.target.value);
  };
  const changeCreatedDateTime = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCreatedDateTime(new Date(e.target.value));
  };
  const changeUpdatedDateTime = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUpdatedDateTime(new Date(e.target.value));
  };

  const isString = (str: string) => !!str?.length;
  const validate = () => {
    if (
      !isString(corridorCode) ||
      !isString(currency) ||
      !isString(importType) ||
      !isString(auditType) ||
      !isString(tradeType2) ||
      !isString(buySell) ||
      !isString(optType) ||
      !isString(mkt1) ||
      !isString(mkt2) ||
      !isString(comp1) ||
      !isString(comp2) ||
      !isString(book) ||
      !isString(firmType) ||
      !isString(schedule) ||
      !isString(broker) ||
      !isString(trader) ||
      !isString(contract) ||
      !isString(unit) ||
      !isString(period) ||
      !isString(days) ||
      !isString(timezone) ||
      !isString(inAreaEicCode) ||
      !isString(outAreaEicCode)
    ) {
      return false;
    }
    return true;
  };
  const onConfirm = () => {
    if (validate()) {
      dispatch(CreateOrUpdateEtrmConfig());
      onCancel();
    }
  };

  const CreateOrUpdateEtrmConfig = () => {
    return PostEtrmConfigAction({
      id: id,
      code: code,
      currency: currency,
      importType: importType,
      auditType: auditType,
      tradeType2: tradeType2,
      buySell: buySell,
      optType: optType,
      mkt1: mkt1,
      mkt2: mkt2,
      comp1: comp1,
      comp2: comp2,
      book: book,
      firmType: firmType,
      schedule: schedule,
      broker: broker,
      trader: trader,
      contract: contract,
      unit: unit,
      period: period,
      days: days,
      tGroup1: tGroup1,
      tGroup4: tGroup4,
      timezone: timezone,
      inAreaEicCode: inAreaEicCode,
      outAreaEicCode: outAreaEicCode,
      corridorCode: corridorCode,
      createdDateTime: createdDateTime,
      updatedDateTime: new Date(),
    } as IEtrmConfig);
  };
  return (
    <div>
      <Modal
        title={`EDIT - ETRM Configs`}
        width="1000px"
        open={open}
        onClose={onCancel}
        actions={[
          {
            label: "Cancel",
            action: onCancel,
            props: {
              variant: Variants.Outlined
            }
          },            
          {
            label: "Save",
            action: onConfirm,
          }
        ]}
      >
        <form>
          <ColumnDiv>
            <FormField
              id="corridorCodeFormField"
              label="Corridor Code"
              description={
                !isString(corridorCode) ? "Please enter a valid value" : ""
              }
            >
              <TextInput
                aria-labelledby="input"
                id="corridorCodeTextInput"
                onChange={changeCorridorCode}
                value={corridorCode}
                autoComplete="off"
              />
            </FormField>
            <FormField
              id="outAreaEicCodeFormField"
              label="Out Area Eic Code"
              description={
                !isString(outAreaEicCode) ? "Please enter a valid value" : ""
              }
            >
              <TextInput
                aria-labelledby="input"
                id="outAreaEicCodeTextInput"
                onChange={changeOutAreaEicCode}
                value={outAreaEicCode}
                autoComplete="off"
              />
            </FormField>
            <FormField
              id="inAreaEicCodeFormField"
              label="In Area Eic Code"
              description={
                !isString(inAreaEicCode) ? "Please enter a valid value" : ""
              }
            >
              <TextInput
                aria-labelledby="input"
                id="inAreaEicCodeTextInput"
                onChange={changeInAreaEicCode}
                value={inAreaEicCode}
                autoComplete="off"
              />
            </FormField>
            <FormField
              id="currency"
              label="Currency"
              description={
                !isString(currency) ? "Please enter a valid value" : ""
              }
            >
              <TextInput
                aria-labelledby="input"
                id="currencyTextInput"
                onChange={changeCurrency}
                value={currency}
                autoComplete="off"
              />
            </FormField>
            <FormField
              id="importTypeFormField"
              label="Import Type"
              description={
                !isString(importType) ? "Please enter a valid value" : ""
              }
            >
              <TextInput
                aria-labelledby="input"
                id="importTypeTextInput"
                onChange={changeImportType}
                value={importType}
                autoComplete="off"
              />
            </FormField>
          </ColumnDiv>
          <ColumnDiv>
            <FormField
              id="auditTypeFormField"
              label="Audit Type"
              description={
                !isString(auditType) ? "Please enter a valid value" : ""
              }
            >
              <TextInput
                aria-labelledby="input"
                id="auditTypeTextInput"
                onChange={changeAuditType}
                value={auditType}
                autoComplete="off"
              />
            </FormField>
            <FormField
              id="tradeType2FormField"
              label="Trade Type2"
              description={
                !isString(tradeType2) ? "Please enter a valid value" : ""
              }
            >
              <TextInput
                aria-labelledby="input"
                id="tradeType2TextInput"
                onChange={changeTradeType2}
                value={tradeType2}
                autoComplete="off"
              />
            </FormField>
            <FormField
              id="buySellFormField"
              label="Buy Sell"
              description={
                !isString(buySell) ? "Please enter a valid value" : ""
              }
            >
              <TextInput
                aria-labelledby="input"
                id="buySellTextInput"
                onChange={changeBuySell}
                value={buySell}
                autoComplete="off"
              />
            </FormField>
            <FormField
              id="optTypeFormField"
              label="Opt Type"
              description={
                !isString(optType) ? "Please enter a valid value" : ""
              }
            >
              <TextInput
                aria-labelledby="input"
                id="optTypeTextInput"
                onChange={changeOptType}
                value={optType}
                autoComplete="off"
              />
            </FormField>
            <FormField
              id="mkt1FormField"
              label="Mkt1"
              description={!isString(mkt1) ? "Please enter a valid value" : ""}
            >
              <TextInput
                aria-labelledby="input"
                id="mkt1TextInput"
                onChange={changeMkt1}
                value={mkt1}
                autoComplete="off"
              />
            </FormField>
          </ColumnDiv>
          <ColumnDiv>
            <FormField
              id="mkt2FormField"
              label="Mkt2"
              description={!isString(mkt2) ? "Please enter a valid value" : ""}
            >
              <TextInput
                aria-labelledby="input"
                id="mkt2TextInput"
                onChange={changeMkt2}
                value={mkt2}
                autoComplete="off"
              />
            </FormField>
            <FormField
              id="comp1FormField"
              label="Comp1"
              description={!isString(comp1) ? "Please enter a valid value" : ""}
            >
              <TextInput
                aria-labelledby="input"
                id="comp1TextInput"
                onChange={changeComp1}
                value={comp1}
                autoComplete="off"
              />
            </FormField>
            <FormField
              id="comp2FormField"
              label="Comp2"
              description={!isString(comp2) ? "Please enter a valid value" : ""}
            >
              <TextInput
                aria-labelledby="input"
                id="comp2TextInput"
                onChange={changeComp2}
                value={comp2}
                autoComplete="off"
              />
            </FormField>
            <FormField
              id="bookFormField"
              label="Book"
              description={!isString(book) ? "Please enter a valid value" : ""}
            >
              <TextInput
                aria-labelledby="input"
                id="bookTextInput"
                onChange={changeBook}
                value={book}
                autoComplete="off"
              />
            </FormField>
            <FormField
              id="firmTypeFormField"
              label="Firm Type"
              description={
                !isString(firmType) ? "Please enter a valid value" : ""
              }
            >
              <TextInput
                aria-labelledby="input"
                id="firmTypeTextInput"
                onChange={changeFirmType}
                value={firmType}
                autoComplete="off"
              />
            </FormField>
          </ColumnDiv>
          <ColumnDiv>
            <FormField
              id="scheduleFormField"
              label="Schedule"
              description={
                !isString(schedule) ? "Please enter a valid value" : ""
              }
            >
              <TextInput
                aria-labelledby="input"
                id="scheduleTextInput"
                onChange={changeSchedule}
                value={schedule}
                autoComplete="off"
              />
            </FormField>
            <FormField
              id="brokerFormField"
              label="Broker"
              description={
                !isString(broker) ? "Please enter a valid value" : ""
              }
            >
              <TextInput
                aria-labelledby="input"
                id="brokerTextInput"
                onChange={changeBroker}
                value={broker}
                autoComplete="off"
              />
            </FormField>
            <FormField
              id="traderFormField"
              label="Trader"
              description={
                !isString(trader) ? "Please enter a valid value" : ""
              }
            >
              <TextInput
                aria-labelledby="input"
                id="traderTextInput"
                onChange={changeTrader}
                value={trader}
                autoComplete="off"
              />
            </FormField>
            <FormField
              id="contractFormField"
              label="Contract"
              description={
                !isString(contract) ? "Please enter a valid value" : ""
              }
            >
              <TextInput
                aria-labelledby="input"
                id="contractTextInput"
                onChange={changeContract}
                value={contract}
                autoComplete="off"
              />
            </FormField>
            <FormField
              id="unitFormField"
              label="Unit"
              description={!isString(unit) ? "Please enter a valid value" : ""}
            >
              <TextInput
                aria-labelledby="input"
                id="unitTextInput"
                onChange={changeUnit}
                value={unit}
                autoComplete="off"
              />
            </FormField>
          </ColumnDiv>
          <ColumnDiv>
            <FormField
              id="periodFormField"
              label="Period"
              description={
                !isString(period) ? "Please enter a valid value" : ""
              }
            >
              <TextInput
                aria-labelledby="input"
                id="periodTextInput"
                onChange={changePeriod}
                value={period}
                autoComplete="off"
              />
            </FormField>
            <FormField
              id="daysFormField"
              label="Days"
              description={!isString(days) ? "Please enter a valid value" : ""}
            >
              <TextInput
                aria-labelledby="input"
                id="daysTextInput"
                onChange={changeDays}
                value={days}
                autoComplete="off"
              />
            </FormField>
            <FormField
              id="timezoneFormField"
              label="Timezone"
              description={
                !isString(timezone) ? "Please enter a valid value" : ""
              }
            >
              <TextInput
                aria-labelledby="input"
                id="timezoneTextInput"
                onChange={changeTimezone}
                value={timezone}
                autoComplete="off"
              />
            </FormField>
            <FormField id="tGroup1FormField" label="TGroup1">
              <TextInput
                aria-labelledby="input"
                id="tGroup1TextInput"
                onChange={changeTGroup1}
                value={tGroup1}
                autoComplete="off"
              />
            </FormField>
            <FormField id="tGroup4FormField" label="TGroup4">
              <TextInput
                aria-labelledby="input"
                id="tGroup4TextInput"
                onChange={changeTGroup4}
                value={tGroup4}
                autoComplete="off"
              />
            </FormField>
          </ColumnDiv>
        </form>
      </Modal>
    </div>
  );
};
